export const ADD_TO_FAVORITES = 'ADD_TO_FAVORITES';
export const REMOVE_FROM_FAVORITES = 'REMOVE_FROM_FAVORITES';
export const CLEAR_FAVORITES = 'CLEAR_FAVORITES';

// Action to add a product to the favorites
export const addToFavorites = (product) => {
  return {
    type: ADD_TO_FAVORITES,
    payload: product,
  };
};

// Action to remove a product from the cart
export const removeFromFavorites = (productId) => {
  return {
    type: REMOVE_FROM_FAVORITES,
    payload: productId,
  };
};

// Action to clear the cart
export const clearFavorites = () => {
  return {
    type: CLEAR_FAVORITES,
  };
};